import axios from "axios";
import { Dispatch } from "react";
import {
    GET_LOCATIONS_COMPREHENSIVE_FAILURE, GET_LOCATIONS_COMPREHENSIVE_REQUEST, GET_LOCATIONS_COMPREHENSIVE_SUCCESS, RESET_LOCATIONS_COMPREHENSIVE_MESSAGE,
} from "../constants/locationsComprehensive.constant";
import { AnyIfEmpty } from "react-redux";

// Request Action
const getLocationsComprehensiveRequest = () => ({
    type: GET_LOCATIONS_COMPREHENSIVE_REQUEST,
});

// Success Action
const getLocationsComprehensiveSuccess = (data: AnyIfEmpty<object>) => ({
    type: GET_LOCATIONS_COMPREHENSIVE_SUCCESS,
    payload: data,
});

// Failure Action
const getLocationsComprehensiveFailure = (error: string) => ({
    type: GET_LOCATIONS_COMPREHENSIVE_FAILURE,
    payload: error,
});

// Reset Action
export const resetLocationsComprehensiveMessage = () => ({
    type: RESET_LOCATIONS_COMPREHENSIVE_MESSAGE,
});


export const getLocationsComprehensive = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationsComprehensiveRequest());

        axios
            .get("/admin/appointments/comprehensive")
            .then((response) => {
                if (response.status === 200 && response.data?.url) {
                    const fileUrl = response.data.url;

                    // Open CSV in new tab
                    window.open(fileUrl, "_self");

                    dispatch(getLocationsComprehensiveSuccess(response.data.message));
                } else {
                    dispatch(
                        getLocationsComprehensiveFailure(
                            response.data?.message || "No file URL returned"
                        )
                    );
                }
            })
            .catch((error) => {
                dispatch(
                    getLocationsComprehensiveFailure(
                        error.response?.data?.message || error.message
                    )
                );
            });
    };
};
